import { MountingPlate } from 'app/features/configuratorData/slice/types';
import { ItemsPriceType } from 'app/features/price/slice/types';
import { StockStatusType } from 'app/features/stock/slice/types';

export const transformMountingPlate: (
  mountingPlate: MountingPlate,
  mountingPlatePrice: Array<ItemsPriceType>,
  mountingPlateStock: Array<StockStatusType>,
) => MountingPlate = (
  mountingPlate: MountingPlate,
  mountingPlatePrice: any,
  mountingPlateStock: any,
) => {
  return {
    ...mountingPlate,
    price: mountingPlatePrice && mountingPlatePrice[0],
    stockStatus: mountingPlateStock && mountingPlateStock[0],
  };
};
